var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from "react";
import { Pane, Button, Row, Col, AccordionSet, Accordion, Checkbox, ErrorModal, PaneFooter, } from "@folio/stripes/components";
import { useQuery } from "react-query";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useHistory, useParams } from "react-router";
import { useOkapiKy } from "@folio/stripes/core";
import { isEqual } from "lodash";
import { useIntl } from "react-intl";
import { createAresSchema } from "../../utils/validationUtils";
import { fetchAddressCode, fetchRegions, getDuplicities, } from "../../api/publisherService";
import { useAddressSuggest } from "../../hooks/useAddressSuggest";
import { fetchAresUpdatesData, updateAres } from "../../api/aresService";
import { DataBoxesAccordion } from "./AresUpdatesDetail/DataBoxesAccordion";
import { AlternativeNameTypeSelect, RecekTextField, RecekSelect, RecekSelection, RecekTextArea, } from "../../components/inputs";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useScrollOnPotentialDuplicates, scrollToError, } from "../../utils/scrollUtils";
import DuplicateTable, { DuplicateDetailPane, useDuplicateTable, } from "../../components/DuplicateTable";
import styles from "./AresUpdatesEdit.module.css";
var AresUpdateEdit = function () {
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var aresSchema = createAresSchema(formatMessage);
    var _a = useForm({
        resolver: zodResolver(aresSchema),
        shouldFocusError: false,
        defaultValues: {
            companyNumber: "",
            name: "",
            nameSuffix: "",
            qualifier: "",
            legalForm: "LEGAL",
            taxNumber: "",
            birthDate: "",
            mainAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            mailingAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            guarantors: [],
            contacts: [],
            alternativeNames: [],
            internalComment: "",
            version: 0,
        },
        mode: "onBlur",
    }), handleSubmit = _a.handleSubmit, register = _a.register, control = _a.control, setValue = _a.setValue, getValues = _a.getValues, reset = _a.reset, _b = _a.formState, errors = _b.errors, dirtyFields = _b.dirtyFields;
    var _c = useState({
        companyNumber: "",
        name: "",
        taxNumber: "",
        addressCode: "",
    }), aresFormValues = _c[0], setAresFormValues = _c[1];
    var _d = useState(false), registration = _d[0], setRegistration = _d[1];
    var _e = useState(false), expandAll = _e[0], setExpandAll = _e[1];
    var _f = useState({
        general: true,
        address: true,
        contacts: true,
        dataBoxes: true,
        alternativeNames: true,
        comments: true,
    }), accordionStatus = _f[0], setAccordionStatus = _f[1];
    var _g = useState(false), errorModalOpen = _g[0], setErrorModalOpen = _g[1];
    var _h = useState(""), errorMessage = _h[0], setErrorMessage = _h[1];
    var _j = useState([]), regions = _j[0], setRegions = _j[1];
    var _k = useState({
        addressCode: "",
        municipality: "",
        postalCode: "",
        region: {
            id: "",
            name: "",
        },
        street: "",
    }), aresAddress = _k[0], setAresAddress = _k[1];
    // DB-876: min. 3 characters, 300 ms debounce
    var addressSuggest = useAddressSuggest(ky);
    var setAddressData = addressSuggest.setAddresses;
    var _l = useState([]), potentialDuplicates = _l[0], setPotentialDuplicates = _l[1];
    var _m = useState(""), duplicateWarning = _m[0], setDuplicateWarning = _m[1];
    var skipDuplicateCheckRef = useRef(false);
    var updatedDataRef = useRef();
    var _o = useDuplicateTable(), selectedDuplicatePublisher = _o.selectedDuplicatePublisher, onClose = _o.onClose, setSelectedDuplicatePublisherId = _o.setSelectedDuplicatePublisherId;
    var topRef = useScrollOnPotentialDuplicates(potentialDuplicates).topRef;
    var _p = useFieldArray({
        control: control,
        name: "alternativeNames",
    }), alternativeNameFields = _p.fields, appendAlternativeName = _p.append, removeAlternativeNameAtIndex = _p.remove;
    var aresData = useQuery(["ares-update-requests", id], function () { return fetchAresUpdatesData(id, ky); }, { enabled: !!id }).data;
    useQuery("regions", function () { return fetchRegions(ky); }, {
        onSuccess: function (data) {
            setRegions(data);
        },
    });
    useEffect(function () {
        if (aresData) {
            reset(aresData.publisher);
            setAresFormValues(aresData.data);
            if (aresData.publisher.status === "REQUEST") {
                setRegistration(true);
            }
        }
    }, [aresData, reset]);
    useEffect(function () {
        if (aresFormValues.addressCode) {
            fetchAddressCode(ky, aresFormValues.addressCode)
                .then(function (publisherAddress) {
                setAresAddress(publisherAddress);
            })
                .catch(function (error) {
                console.error("Error fetching ares address:", error);
                setAddressData([]);
            });
        }
    }, [aresFormValues.addressCode, setAddressData]);
    useEffect(function () {
        if (aresData && aresData.publisher) {
            getDuplicities(ky, aresData.publisher)
                .then(function (_a) {
                var publishers = _a.publishers;
                if (publishers && publishers.length > 0) {
                    setPotentialDuplicates(publishers.filter(function (pub) { return pub.id !== id; }));
                }
                else {
                    setPotentialDuplicates([]);
                }
            })
                .catch(function (error) {
                return console.error("Error fetching duplicates on load:", error);
            });
        }
    }, [aresData]);
    useEffect(function () {
        if (Object.keys(errors).length > 0) {
            scrollToError(errors);
        }
    }, [errors]);
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        // Ensure name is a valid form key
        if (name in getValues()) {
            setValue(name, value, { shouldValidate: true });
        }
    };
    var handleAddressSelection = function (selectedValue, type) { return __awaiter(void 0, void 0, void 0, function () {
        var addressDetails, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchAddressCode(ky, selectedValue)];
                case 1:
                    addressDetails = _a.sent();
                    setValue("".concat(type, ".addressCode"), selectedValue, { shouldValidate: true });
                    setValue("".concat(type, ".street"), addressDetails.street, { shouldValidate: true });
                    setValue("".concat(type, ".postalCode"), addressDetails.postalCode, { shouldValidate: true });
                    setValue("".concat(type, ".municipality"), addressDetails.municipality, { shouldValidate: true });
                    setValue("".concat(type, ".region"), addressDetails.region || { id: "", name: "" }, { shouldValidate: true });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching ".concat(type, " details:"), error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var toggleExpandCollapseAll = function () {
        setExpandAll(!expandAll);
        setAccordionStatus({
            general: !expandAll,
            address: !expandAll,
            contacts: !expandAll,
            dataBoxes: !expandAll,
            alternativeNames: !expandAll,
            comments: !expandAll,
        });
    };
    var onSubmit = function (data, status) { return __awaiter(void 0, void 0, void 0, function () {
        var publisherData, publishers, filteredDuplicates, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    publisherData = __assign(__assign(__assign({}, aresData === null || aresData === void 0 ? void 0 : aresData.publisher), data), { status: status });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    if (!(Object.keys(dirtyFields).length === 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateAres(ky, id, publisherData)];
                case 2:
                    _a.sent();
                    history.goBack();
                    return [2 /*return*/];
                case 3:
                    if (!(!skipDuplicateCheckRef.current ||
                        !isEqual(data, updatedDataRef.current))) return [3 /*break*/, 5];
                    return [4 /*yield*/, getDuplicities(ky, data)];
                case 4:
                    publishers = (_a.sent()).publishers;
                    if (publishers && publishers.length > 0) {
                        filteredDuplicates = publishers.filter(function (pub) { return pub.id !== id; });
                        if (filteredDuplicates.length > 0) {
                            setPotentialDuplicates(filteredDuplicates);
                            setDuplicateWarning(formatMessage({
                                id: "ares.warning.message.duplicatesFound.save",
                            }));
                            skipDuplicateCheckRef.current = true;
                            updatedDataRef.current = data;
                            return [2 /*return*/];
                        }
                    }
                    _a.label = 5;
                case 5: return [4 /*yield*/, updateAres(ky, id, publisherData)];
                case 6:
                    _a.sent();
                    skipDuplicateCheckRef.current = false;
                    setDuplicateWarning("");
                    history.goBack();
                    return [3 /*break*/, 8];
                case 7:
                    error_2 = _a.sent();
                    console.error("Error updating publisher:", error_2);
                    setErrorMessage(formatMessage({ id: "ui-br-publishers.error.ares.edit" }, { error: String(error_2) }));
                    setErrorModalOpen(true);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-publishers.ares.updates.edit.pane.title",
            }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { buttonStyle: "primary", type: "submit", onClick: handleSubmit(function (data) { return onSubmit(data, "ACTIVE"); }) }, registration
                    ? formatMessage({ id: "ui-br-publishers.button.approve" })
                    : formatMessage({ id: "ui-br-publishers.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: registration
                        ? handleSubmit(function (data) { return onSubmit(data, "REJECTED"); })
                        : function () { return history.goBack(); } }, registration
                    ? formatMessage({ id: "ui-br-publishers.button.reject" })
                    : formatMessage({
                        id: "ui-br-publishers.button.cancel.action",
                    })) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({ id: "ui-br-publishers.error.label" }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } },
                React.createElement("div", null, errorMessage),
                React.createElement(Button, { onClick: function () { return setErrorModalOpen(false); } }, formatMessage({ id: "ui-br-publishers.button.close" }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll
                        ? formatMessage({ id: "ui-br-publishers.button.collapse.all" })
                        : formatMessage({ id: "ui-br-publishers.button.expand.all" })))),
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(AccordionSet, null,
                    React.createElement("div", { ref: topRef }),
                    (potentialDuplicates === null || potentialDuplicates === void 0 ? void 0 : potentialDuplicates.length) > 0 ? (React.createElement(Accordion, { id: "duplicates-table", label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.potentialDuplicates",
                        }) },
                        duplicateWarning && (React.createElement("div", { className: styles.warning }, duplicateWarning)),
                        React.createElement(DuplicateTable, { duplicates: potentialDuplicates, onDuplicateClick: setSelectedDuplicatePublisherId }))) : null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.accordion.label.general",
                        }), open: accordionStatus.general, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "companyNumber", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.companyNumber", required: true, highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.companyNumber) !==
                                                aresFormValues.companyNumber }, field, { error: (_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-publishers.ares.field.label.companyNumber.registry", name: "companyNumber", disabled: true, value: aresFormValues.companyNumber, onChange: handleInputChange })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.name.legal" }, field, { required: true, highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.name) !== aresFormValues.name, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-publishers.ares.field.label.name.registry", name: "name", disabled: true, value: aresFormValues.name, onChange: handleInputChange }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "nameSuffix", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.nameSuffix" }, field)));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "qualifier", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.qualifier" }, field, { error: (_b = errors.qualifier) === null || _b === void 0 ? void 0 : _b.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "legalForm", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-publishers.field.label.legalForm", highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.legalForm) !==
                                                aresFormValues.legalForm }),
                                            React.createElement("option", { value: "UNKNOWN" }, formatMessage({
                                                id: "ui-br-publishers.publishers.general.select.legal.form.unknown",
                                            })),
                                            React.createElement("option", { value: "LEGAL" }, formatMessage({
                                                id: "ui-br-publishers.publishers.general.select.label.legal",
                                            })),
                                            React.createElement("option", { value: "NATURAL" }, formatMessage({
                                                id: "ui-br-publishers.publishers.general.select.label.natural",
                                            }))));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekSelect, { labelId: "ui-br-publishers.ares.field.label.legalForm.registry", name: "legalForm", disabled: true, value: aresFormValues.legalForm, onChange: handleInputChange },
                                    React.createElement("option", { value: "LEGAL" }, formatMessage({
                                        id: "ui-br-publishers.publishers.general.select.label.legal",
                                    })),
                                    React.createElement("option", { value: "NATURAL" }, formatMessage({
                                        id: "ui-br-publishers.publishers.general.select.label.natural",
                                    }))))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "taxNumber", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.taxNumber" }, field, { required: true, highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.taxNumber) !==
                                                aresFormValues.taxNumber, error: (_b = errors.taxNumber) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-publishers.ares.field.label.taxNumber.registry", name: "taxNumber", disabled: true, value: aresFormValues.taxNumber, onChange: handleInputChange })))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.accordion.label.address.main",
                        }), open: accordionStatus.address, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { address: !accordionStatus.address }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.addressCode", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, __assign({}, field, { labelId: "ui-br-publishers.field.label.address", asyncFilter: true, onFilter: addressSuggest.onFilter, loading: addressSuggest.loading, loadingMessage: formatMessage({
                                                id: "ui-br-publishers.address.suggest.loading",
                                            }), emptyMessage: formatMessage({
                                                id: addressSuggest.emptyMessageId,
                                            }), dataOptions: addressSuggest.addresses.map(function (address) { return ({
                                                value: address.addressCode,
                                                label: address.address,
                                            }); }), highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.mainAddress.addressCode) !==
                                                aresFormValues.addressCode, onChange: function (selectedValue) {
                                                field.onChange(selectedValue);
                                                handleAddressSelection(selectedValue, "mainAddress");
                                            } })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekSelection, { labelId: "ui-br-publishers.ares.field.label.address.registry", name: "publisherAddress", value: aresData === null || aresData === void 0 ? void 0 : aresData.data.addressCode, onChange: handleAddressSelection, asyncFilter: true, required: true, disabled: true, onFilter: addressSuggest.onFilter, dataOptions: __spreadArray([], addressSuggest.addresses.map(function (address) { return ({
                                        value: address.addressCode,
                                        label: address.address,
                                    }); }), true) })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.region.id", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-publishers.field.label.region", required: true, error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.message, dataOptions: __spreadArray([
                                                {
                                                    value: "",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.field.label.region.select.placeholder",
                                                    }),
                                                }
                                            ], regions.map(function (region) { return ({
                                                value: region.id,
                                                label: region.name,
                                            }); }), true), highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.mainAddress.region.id) !==
                                                aresAddress.region.id, onChange: function (e) {
                                                var selectedRegion = regions.find(function (region) { return region.id === e.target.value; });
                                                setValue("mainAddress.region", selectedRegion || { id: "", name: "" });
                                            } })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekSelect, { labelId: "ui-br-publishers.ares.field.label.region.registry", name: "mainAddressRegion", required: true, disabled: true, value: aresAddress.region.id, dataOptions: __spreadArray([
                                        {
                                            value: "",
                                            label: formatMessage({
                                                id: "ui-br-publishers.field.label.region.select.placeholder",
                                            }),
                                        }
                                    ], regions.map(function (region) { return ({
                                        value: region.id,
                                        label: region.name,
                                    }); }), true) })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.street", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-publishers.publishers.mainAddress.field.label.street", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message, highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.mainAddress.street) !==
                                                aresAddress.street })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-publishers.ares.field.label.street.registry", name: "street", value: aresAddress.street, disabled: true, required: true })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.postalCode", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-publishers.publishers.mainAddress.field.label.postalCode", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message, highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.mainAddress.postalCode) !==
                                                aresAddress.postalCode })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-publishers.ares.field.label.postalCode.registry", name: "postalCode", value: aresAddress.postalCode, disabled: true, required: true })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.municipality", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-publishers.publishers.mainAddress.field.label.municipality", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message, highlight: (aresData === null || aresData === void 0 ? void 0 : aresData.publisher.mainAddress.municipality) !==
                                                aresAddress.municipality })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-publishers.ares.field.label.municipality.registry", name: "municipality", value: aresAddress.municipality, disabled: true, required: true })))),
                    aresData ? (React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.ares.accordions.label.dataBoxes",
                        }), open: accordionStatus.dataBoxes, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { dataBoxes: !accordionStatus.dataBoxes }));
                        } },
                        React.createElement(DataBoxesAccordion, { data: aresData.data, publisher: aresData.publisher }))) : null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.accordion.label.alternativeNames",
                        }), open: accordionStatus.alternativeNames, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { alternativeNames: !accordionStatus.alternativeNames }));
                        } },
                        alternativeNameFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                            React.createElement(Col, { xs: 12, md: 4 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".name"), defaultValue: field.name, render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-publishers.field.label.alternativeName", required: true, error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 4 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nameSuffix"), defaultValue: field.nameSuffix, render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-publishers.field.label.nameSuffix", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.nameSuffix) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 4 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".qualifier"), defaultValue: field.qualifier, render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-publishers.field.label.qualifier", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.qualifier) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 4 },
                                React.createElement(AlternativeNameTypeSelect, { control: control, name: "alternativeNames.".concat(index, ".type"), labelId: "ui-br-publishers.field.label.type" })),
                            React.createElement(Col, { xs: 12, md: 2 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nonPublic"), defaultValue: field.nonPublic, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) { return field.onChange(e.target.checked); }, label: formatMessage({
                                                id: "ui-br-publishers.field.label.nonPublic",
                                            }) }));
                                    } })),
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeAlternativeNameAtIndex(index); }, style: { marginTop: "10px" } }, formatMessage({
                                    id: "ui-br-publishers.button.remove.alternativeName",
                                }))))); }),
                        React.createElement(Button, { onClick: function () {
                                return appendAlternativeName({
                                    name: "",
                                    nameSuffix: "",
                                    qualifier: "",
                                    type: undefined,
                                    nonPublic: false,
                                }, { shouldFocus: false });
                            } }, formatMessage({
                            id: "ui-br-publishers.button.add.alternativeName",
                        }))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.accordion.label.comments",
                        }), open: accordionStatus.comments, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { comments: !accordionStatus.comments }));
                        } },
                        React.createElement(RecekTextArea, __assign({ labelId: "ui-br-publishers.field.label.comment" }, register("internalComment"), { onChange: handleInputChange })))))),
        React.createElement(DuplicateDetailPane, { selectedDuplicatePublisher: selectedDuplicatePublisher, onClose: onClose })));
};
export default AresUpdateEdit;
